import RatingStars from '@components/partials/site/rating/ratingStars';
import styles from '@styles/scss/category/categoryTopSites.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { parseCookies } from 'nookies';
import React from 'react';
import { useEffect, useState } from 'react';

import CategoryTopSiteCard from './catgeoryTopSiteCard';
const languageFiles = (require as any).context('public/locales', false, /\.json$/);

export default function CategoryTopSites({
    topSiteDataList,
    activeSites,
    categoryName,
    currentLang
}: {
    topSiteDataList: any;
    activeSites: any;
    categoryName: string;
    currentLang: string;
}): JSX.Element {
    const languageFile = languageFiles(`./${currentLang}.json`);
    const title = languageFile.top_sites_title.replace('%CATEGORY_NAME%', categoryName);
    return (
        <div className={styles.topSitesWrapper}>
            <div className={styles.categoryBanner}>{title}</div>
            <div className={styles.topThreeSites}>
                {Object.values(topSiteDataList).map((site: any, index: number) => (
                    <CategoryTopSiteCard
                        key={site.slug}
                        site={site}
                        languageFile={languageFile}
                        index={index}
                        activeSites={activeSites}
                        categoryName={categoryName}
                        currentLang={currentLang}
                    />
                ))}
            </div>
        </div>
    );
}
